/**
 * Миксин для работы с алертами
 */
export default {
    methods: {
        alertError(data, opts = {}) {
            this.$toast.add({
                ...{
                    severity: 'error',
                    summary: this.$t('lang.main.toast.error_title'),
                    detail: data.message ?? data,
                    life: 5000,
                    closable: false,
                },
                ...opts
            });
        },
        alertInfo(data, opts = {}) {
            this.$toast.add({
                ...{
                    severity: 'info',
                    summary: this.$t('lang.main.toast.info_title'),
                    detail: data.message ?? data,
                    life: 2000,
                    closable: false,
                },
                ...opts
            });
        },
        alertSuccess(data, opts = {}) {
            this.$toast.add({
                ...{
                    summary: null,
                    severity: 'success',
                    detail: data.message ?? data,
                    life: 2000,
                    closable: false,
                },
                ...opts
            })
        }
    }
}
